import { reviewFilterConfig } from "~/config/reviewFilter.config.js";

export const useProductReviewStore = defineStore("product-review", () => {
  const route = useRoute();

  const reviews = ref([]);
  const galleryReviews = ref([]);
  const params = ref(fromRoute());
  const pageCount = ref(1);

  const fetch = async (product) => {
    await useAsyncData("fetchProductReviewData", async () => {
      await Promise.all([
        fetchReviews(
          {
            filters: {
              productCode: product.code,
            },
          },
          {
            ...toRequestParams(),
          },
        ),
        fetchReviews(
          {
            filters: {
              productCode: product.code,
              $or: {
                0: {
                  attachments: {
                    $notNull: true,
                  },
                },
                1: {
                  youtubeVideoId: {
                    $notNull: true,
                  },
                },
              },
            },
          },
          { page: 1, pageSize: 100 },
        ),
      ]).then(([dtoReviews, dtoGalleryReviews]) => {
        reviews.value = dtoReviews.data;
        pageCount.value = dtoReviews.meta.pagination.pageCount;
        galleryReviews.value = dtoGalleryReviews.data;
      });
    });
  };

  const loadMore = async (product, page) => {
    const { data } = await fetchReviews(
      {
        filters: {
          productCode: product.code,
        },
      },
      {
        ...toRequestParams(),
        page,
      },
    );

    reviews.value.push(...data);
  };

  function toRequestParams() {
    const requestParams = {};

    for (const [paramKey, paramValue] of Object.entries(params.value)) {
      requestParams[reviewFilterConfig[paramKey].request?.alias ?? paramKey] =
        reviewFilterConfig[paramKey].request?.encode(paramValue) ??
        reviewFilterConfig[paramKey].state.encode(paramValue);
    }

    return requestParams;
  }

  function fromRoute() {
    const filterParams = {};

    for (const configKey in reviewFilterConfig) {
      const filterValue = route.params[configKey] || route.query[configKey];

      if (undefined !== filterValue) {
        filterParams[configKey] =
          reviewFilterConfig[configKey].state.decode(filterValue);
      } else {
        filterParams[configKey] = reviewFilterConfig[configKey].default();
      }
    }

    return filterParams;
  }

  function toRoute() {
    const routeLocation = {
      params: {},
      query: {},
    };

    for (const paramKey in params.value) {
      const encodedParamValue = reviewFilterConfig[paramKey].state.encode(
        params.value[paramKey],
      );

      if (undefined !== encodedParamValue) {
        routeLocation[reviewFilterConfig[paramKey].source][paramKey] =
          encodedParamValue;
      }
    }

    return routeLocation;
  }

  watch(
    params,
    () => {
      return navigateTo({ ...toRoute() });
    },
    { deep: true },
  );

  return {
    reviews,
    galleryReviews,
    params,
    pageCount,
    fetch,
    loadMore,
  };
});
